module.exports = __webpack_public_path__ + "img/Slika4_2021.92a49990.png";